import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type ConversationClaimedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_CLAIMED'>;
};

export const ConversationClaimed = ({
  entry,
}: ConversationClaimedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const text = (
    <>
      Conversation is claimed by {authorLink}{' '}
      {entry.claimed_from_type ? (
        <>
          from {entry.claimed_from_type.toLowerCase()}{' '}
          {entry.claimed_from_label ?? ''}
        </>
      ) : (
        ''
      )}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
